import {SubjectExpertsList} from "./SubjectExpertsList";
import {SubjectExpertsEdit} from "./SubjectExpertsEdit";
import {SubjectExpertsCreate} from "./SubjectExpertsCreate";

export default {
    list: SubjectExpertsList,
    create: SubjectExpertsCreate,
    edit: SubjectExpertsEdit
};
